import React from 'react'

function IconList() {
  return (
    <svg
      width="24"
      height="29"
      viewBox="0 0 24 29"
      fill="none"
      id="addList"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_101_44)">
        <path
          d="M8 7.25H21"
          stroke="#CAD3AF"
          strokeOpacity="0.941176"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M8 14.5H21"
          stroke="#CAD3AF"
          strokeOpacity="0.941176"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M8 21.75H21"
          stroke="#CAD3AF"
          strokeOpacity="0.941176"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_44">
          <rect width="24" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default IconList
